import { AvailableChildrenType, SugarElementInfo } from "../../Suggester/SugarElementInfo";

export const enterEvent: SugarElementInfo = {
    name: "enterEvent",
    availableChildren: { type: AvailableChildrenType.Any },
};
